<script>
import RichText from "@/components/ui/RichText.vue";
import {getNoDateElectionPlaceholderText} from "@/lib";

export default {
  name: "Keypoints",
  components: {RichText},
  props: ["keypoints", "lastUpdatedDate"],
  methods: {
    getTextOrDefault(value) {
      if(value && value.trim().length > 0) {
        return value;
      }

      return getNoDateElectionPlaceholderText(this.lastUpdatedDate);
    }
  },
  computed: {
    education() {
      return this.getTextOrDefault(this.keypoints?.educationAndDigitalization);
    },
    mobility() {
      return this.getTextOrDefault(this.keypoints?.mobilityAndTransportation);
    },
    sustainabilityAndRenewables() {
      return this.getTextOrDefault(this.keypoints?.sustainabilityAndRenewableEnergies);
    },
    neighborhoodDevelopment() {
      return this.getTextOrDefault(this.keypoints?.neighborhoodDevelopment);
    },
    regionalCommitment() {
      return this.getTextOrDefault(this.keypoints?.regionalCommitment);
    },
    other() {
      return this.getTextOrDefault(this.keypoints?.other);
    }
  }
}
</script>

<template>
<div class="keypoints-container">
  <span class="keypoint-header">Bildung & Digitalisierung</span>
  <rich-text class="keypoint-text" :source="education"/>
  <span class="keypoint-header">Mobilität & ÖPNV</span>
  <rich-text class="keypoint-text" :source="mobility"/>
  <span class="keypoint-header">Nachhaltigkeit & regenerative Energien</span>
  <rich-text class="keypoint-text" :source="sustainabilityAndRenewables"/>
  <span class="keypoint-header">Quartiersentwicklung</span>
  <rich-text class="keypoint-text" :source="neighborhoodDevelopment"/>
  <span class="keypoint-header">Regionales Engagement</span>
  <rich-text class="keypoint-text" :source="regionalCommitment"/>
  <span class="keypoint-header">Sonstiges</span>
  <rich-text class="keypoint-text" :source="other"/>
</div>
</template>

<style scoped>
.keypoint-header {
  padding-top: 16px;
  font-family: "GeometriaMedium", sans-serif;
}
.keypoint-text {
  padding-top: 16px;
}
</style>